import { decodeJwt } from 'jose'

export const decodeToken = (token) => {
    if (token) {
        return decodeJwt(token)
    }
    return null
}

export const getRefreshTokenInterval = (interval) =>  {
    // refresh token earlier than the expiration time
    const refreshTimer = .5
    return refreshTimer * interval
}

export const getTokenExpiration = (auth) => {
    let interval = 10 // refresh every 10 minutes
    let exp = null
    let authState = auth
    try {
        // auth state that is retrieved from the localstore is a string
        if (typeof authState === 'string') {
            authState = JSON.parse(authState)
        }
        const { lifespan, token } = authState
        if (token) {
            // create a consistent token expiration interval;
            // this will be re-calculated internally by the react-auth-kit
            // to get the token expiration time: 
            // https://github.com/react-auth-kit/react-auth-kit/blob/5c5ee5272a5e3a39418b0d5cbc62af61c29bd7c3/src/utils/reducers.ts#L57-L77.
            const decoded = decodeToken(token)
            exp = decoded?.exp || decoded?.expiration
            interval = lifespan
        }
    } catch (e) {
        console.debug('Error calculating refresh token interval ', e)
    }
    return {
        interval: getRefreshTokenInterval(interval),
        expiration: exp,
    }
}